import {
    HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoadingService } from '@app/shared/components/loading/loading.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AlertService } from '../services/alert.service';

@Injectable({
    providedIn: 'root'
  })
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(
    private alert: AlertService,
    private loading: LoadingService
  ) {}
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(err => this.errorHandler(err));
  }

  public errorHandler<T>(
    source$: Observable<T>,
    message?: string
  ): Observable<T> {
    return source$.pipe(
      catchError((err) => {
        if (err instanceof HttpErrorResponse) {
          // use supplied message if available, otherwise use default (from server) then url (from client)
          message =
            message ?? err.error.message
              ? err.error.message
              : err.url.split('?')[0];
          this.alert.alert({
            message: (message ? 'Error: ' + message : null) ?? err.statusText,
            type: 'danger',
            duration: 4000,
          });
          this.loading.clearLoading();
          return throwError(err);
        }
      })
    );
  }
}
